var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"5","y1":"18.9393","x2":"19.9393","y2":"4","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"5.20281","y1":"4.14214","x2":"20.1422","y2":"19.0815","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","key":1})]);
}

IconClose.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconClose;

IconClose.default = IconClose;
